import React, { useState } from 'react';
import api from '../../services/axios';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

export const ExportFile = () => {
  const { id } = useParams();
    const navigate = useNavigate();
    React.useEffect(() => {
    if (id)
      DownloadFile(id)
  }, [id]);
  const DownloadFile = async (val) => {
    try {
        api.get("files/ExportFiles?BlobGuid=" + val, { responseType: 'blob', }).then(response => {
            if (response.headers !== undefined) {
                const name = response.headers['content-disposition'].split('filename=')[1].split('.')[0];
                const extension = response.headers['content-disposition'].split('.')[1].split(';')[0];
                const filename = `${name}.${extension}`;
                // Create a blob URL for the file
                const blobURL = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = blobURL;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobURL);
                navigate('/')
            }
            else {
                navigate('/')
            }
      
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  return (
    <>
    </>
  )
}

export default ExportFile;
